module.exports = __webpack_public_path__ + "static/media/shopping-cart@3x.d70ddc47.png";